import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";

const API = "https://wwwa.isepsantafe.net.ar/expedientes";
const BASE_ARCHIVOS = "https://wwwa.isepsantafe.net.ar";

const EvaluarVideoEntrevista = ({
  dni,
  procesoId,
  itemId,
  estadoInicial = "cargado",
  notaInicial = "",
  observacionesIniciales = "",
  onGuardado,
}) => {
  const [cargando, setCargando] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [video, setVideo] = useState(null);
  const [item, setItem] = useState(null);

  const [nota, setNota] = useState(notaInicial);
  const [estado, setEstado] = useState(estadoInicial);
  const [observaciones, setObservaciones] = useState(observacionesIniciales);
const Usuario=ObtieneDatosCookies()
  useEffect(() => {
    obtenerVideo();
  }, [dni, procesoId, itemId]);

  const obtenerVideo = async () => {
    try {
      setCargando(true);

      const res = await axios.post(
        `${API}/ingresos/persona-item/obtiene-video-entrevista`,
        {
          dni,
          proceso_id: procesoId,
          item_id: itemId,
        }
      );

      const itemDevuelto = res.data?.item || null;

      setVideo(res.data?.video || null);
      setItem(itemDevuelto);

      if (itemDevuelto?.resultado !== undefined && itemDevuelto?.resultado !== null) {
        setNota(itemDevuelto.resultado);
      }

      if (itemDevuelto?.estado) {
        setEstado(itemDevuelto.estado);
      }

      if (itemDevuelto?.observaciones) {
        setObservaciones(itemDevuelto.observaciones);
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "No se pudo obtener el video", "error");
    } finally {
      setCargando(false);
    }
  };

  const getUrlVideo = () => {
    if (!video?.url) return "";
    if (video.url.startsWith("http")) return video.url;
    return `${BASE_ARCHIVOS}${video.url}`;
  };

  const getColorNota = (valor) => {
    if (valor <= 3) return "linear-gradient(135deg, #dc2626, #7f1d1d)";
    if (valor <= 5) return "linear-gradient(135deg, #f97316, #9a3412)";
    if (valor <= 7) return "linear-gradient(135deg, #facc15, #ca8a04)";
    if (valor <= 9) return "linear-gradient(135deg, #22c55e, #15803d)";
    return "linear-gradient(135deg, #16a34a, #064e3b)";
  };

  const getTextoNota = () => {
    const n = Number(nota);

    if (nota === "" || Number.isNaN(n)) return "Seleccione una calificación";
    if (n <= 3) return "No recomendable";
    if (n <= 5) return "Condicional";
    if (n <= 7) return "Aceptable";
    if (n <= 9) return "Muy bueno";
    return "Excelente";
  };

  const getColorEstado = (valor) => {
    switch (valor) {
      case "aprobado":
        return "#16a34a";
      case "rechazado":
        return "#dc2626";
      case "pendiente":
        return "#f97316";
      case "cargado":
        return "#2563eb";
      default:
        return "#6b7280";
    }
  };

const guardarEvaluacion = async () => {
  const notaNumero = Number(nota);

  if (nota === "" || Number.isNaN(notaNumero)) {
    Swal.fire(
      "Falta la nota",
      "Debe seleccionar una calificación.",
      "warning"
    );
    return;
  }

  if (!estado) {
    Swal.fire(
      "Falta el estado",
      "Debe seleccionar un estado.",
      "warning"
    );
    return;
  }

  if (!observaciones?.trim()) {
    Swal.fire(
      "Observaciones requeridas",
      "Debe ingresar observaciones de la entrevista.",
      "warning"
    );
    return;
  }

  if (notaNumero < 0 || notaNumero > 10) {
    Swal.fire(
      "Nota inválida",
      "La nota debe estar entre 0 y 10.",
      "warning"
    );
    return;
  }

  if (notaNumero < 6 && estado === "aprobado") {
    const confirmar = await Swal.fire({
      title: "Atención",
      html: `
        <div style="font-size:15px">
          La nota seleccionada es
          <b>${notaNumero}</b>.
          <br/><br/>
          Una nota menor a <b>6</b> normalmente no debería aprobarse.
          <br/><br/>
          ¿Desea continuar igualmente?
        </div>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, aprobar igualmente",
      cancelButtonText: "Volver",
      confirmButtonColor: "#f59e0b",
    });

    if (!confirmar.isConfirmed) return;
  }

  try {
    setGuardando(true);
const evaluador = `${Usuario.identificacion} - ${Usuario.apellido} ${Usuario.nombre}`;

const observacionFinal = `
Evaluador: ${evaluador}
Fecha: ${new Date().toLocaleString("es-AR")}

${observaciones}
`.trim();
 await axios.post(`${API}/ingresos/togglePersonaItem`, {
  persona_id: dni,
  proceso_id: procesoId,
  item_id: itemId,
  tipo: "video",
  resultado: String(notaNumero),
  observaciones: observacionFinal,
  estado,
});

    Swal.fire({
      icon: "success",
      title: "Evaluación guardada",
      text: "La evaluación fue registrada correctamente.",
      timer: 1800,
      showConfirmButton: false,
    });

    if (onGuardado) onGuardado();
  } catch (error) {
    console.error(error);

    Swal.fire(
      "Error",
      "No se pudo guardar la evaluación.",
      "error"
    );
  } finally {
    setGuardando(false);
  }
};

  if (cargando) {
    return (
      <div style={styles.loadingBox}>
        <div style={styles.spinner}></div>
        <p style={styles.loadingText}>Buscando video de entrevista...</p>
      </div>
    );
  }

  if (!video) {
    return (
      <div style={styles.alerta}>
        <div style={styles.alertaIcono}>🎥</div>
        <div>Esta persona todavía no tiene video cargado.</div>
      </div>
    );
  }

  return (
    <div style={styles.page}>
      <div style={styles.contenedor}>
        <div style={styles.header}>
          <div>
            <h3 style={styles.titulo}>Evaluación de entrevista</h3>
            <p style={styles.subtitulo}>
              Visualización del video, calificación y observaciones del evaluador.
            </p>
          </div>

          <div
            style={{
              ...styles.badgeEstado,
              background: getColorEstado(estado),
            }}
          >
            {estado}
          </div>
        </div>

        <div style={styles.videoCard}>
          <video
            src={getUrlVideo()}
            controls
            preload="metadata"
            style={styles.video}
          />
        </div>

        <div style={styles.info}>
          <div style={styles.infoItem}>
            <span style={styles.infoLabel}>Archivo</span>
            <b style={styles.infoValue}>{video.nombre || "entrevista"}</b>
          </div>

          <div style={styles.infoItem}>
            <span style={styles.infoLabel}>Tamaño</span>
            <b style={styles.infoValue}>
              {video.size ? `${(video.size / 1024 / 1024).toFixed(2)} MB` : "-"}
            </b>
          </div>

          <div style={styles.infoItem}>
            <span style={styles.infoLabel}>Estado actual</span>
            <b style={styles.infoValue}>{item?.estado || "-"}</b>
          </div>

          <div style={styles.infoItem}>
            <span style={styles.infoLabel}>Resultado actual</span>
            <b style={styles.infoValue}>{item?.resultado || "-"}</b>
          </div>
        </div>

        <div style={styles.panel}>
          <label style={styles.label}>Calificación</label>

          <div style={styles.grillaNotas}>
            {[ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((valor) => {
              const seleccionado = Number(nota) === valor;

              return (
                <button
                  key={valor}
                  type="button"
                  onClick={() => setNota(valor)}
                  style={{
                    ...styles.botonNota,
                    background: getColorNota(valor),
                    transform: seleccionado ? "translateY(-4px) scale(1.08)" : "scale(1)",
                    border: seleccionado
                      ? "3px solid #111827"
                      : "2px solid rgba(255,255,255,0.55)",
                    boxShadow: seleccionado
                      ? "0 14px 28px rgba(17,24,39,.35)"
                      : "0 8px 18px rgba(15,23,42,.16)",
                  }}
                >
                  {valor}
                </button>
              );
            })}
          </div>

          <div style={styles.resultadoNota}>
            <span style={styles.resultadoTexto}>{getTextoNota()}</span>
            {nota !== "" && (
              <span style={styles.resultadoNumero}>{nota}/10</span>
            )}
          </div>
{nota !== "" &&
  Number(nota) < 6 &&
  estado === "aprobado" && (
    <div
      style={{
        marginTop: 12,
        padding: 14,
        borderRadius: 12,
        background: "#fff7ed",
        border: "1px solid #fdba74",
        color: "#9a3412",
        fontWeight: 700,
      }}
    >
      ⚠️ La nota seleccionada es menor a 6 y el estado está marcado como
      APROBADO.
    </div>
)}
          <label style={styles.label}>Estado</label>
          <select
            value={estado}
            onChange={(e) => setEstado(e.target.value)}
            style={{
              ...styles.input,
              borderLeft: `6px solid ${getColorEstado(estado)}`,
            }}
          >
            <option value="pendiente">Pendiente</option>
            <option value="cargado">Cargado</option>
            <option value="aprobado">Aprobado</option>
            <option value="rechazado">Rechazado</option>
          </select>

          <label style={styles.label}>Observaciones</label>
          <textarea
            value={observaciones}
            onChange={(e) => setObservaciones(e.target.value)}
            rows={4}
            placeholder="Escriba observaciones sobre la entrevista..."
            style={styles.textarea}
          />

          <button
            onClick={guardarEvaluacion}
            disabled={guardando}
            style={{
              ...styles.boton,
              opacity: guardando ? 0.65 : 1,
              cursor: guardando ? "not-allowed" : "pointer",
            }}
          >
            {guardando ? "Guardando evaluación..." : "Guardar evaluación"}
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  page: {
    width: "100%",
    minHeight: "100%",
    padding: "20px",
    background:
      "linear-gradient(135deg, #eef2ff 0%, #f8fafc 45%, #ecfeff 100%)",
    borderRadius: 18,
  },

  contenedor: {
    width: "100%",
    maxWidth: 980,
    margin: "0 auto",
    background: "rgba(255,255,255,.92)",
    borderRadius: 22,
    padding: 22,
    boxShadow: "0 24px 60px rgba(15,23,42,.16)",
    border: "1px solid rgba(148,163,184,.35)",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 14,
    marginBottom: 18,
  },

  titulo: {
    margin: 0,
    fontSize: 26,
    fontWeight: 900,
    color: "#0f172a",
    letterSpacing: "-0.5px",
  },

  subtitulo: {
    margin: "6px 0 0",
    color: "#64748b",
    fontSize: 14,
    lineHeight: 1.4,
  },

  badgeEstado: {
    color: "#fff",
    padding: "9px 14px",
    borderRadius: 999,
    fontWeight: 900,
    textTransform: "uppercase",
    fontSize: 12,
    letterSpacing: ".6px",
    boxShadow: "0 8px 18px rgba(15,23,42,.18)",
    whiteSpace: "nowrap",
  },

  videoCard: {
    background: "linear-gradient(135deg, #020617, #111827)",
    borderRadius: 18,
    padding: 10,
    boxShadow: "inset 0 0 0 1px rgba(255,255,255,.06)",
  },

  video: {
    width: "100%",
    maxHeight: "58vh",
    background: "#020617",
    borderRadius: 14,
    display: "block",
  },

  info: {
    marginTop: 16,
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))",
    gap: 12,
  },

  infoItem: {
    background: "#f8fafc",
    border: "1px solid #e2e8f0",
    borderRadius: 14,
    padding: "12px 14px",
  },

  infoLabel: {
    display: "block",
    color: "#64748b",
    fontSize: 12,
    fontWeight: 800,
    textTransform: "uppercase",
    letterSpacing: ".5px",
    marginBottom: 4,
  },

  infoValue: {
    color: "#0f172a",
    fontSize: 14,
    wordBreak: "break-word",
  },

  panel: {
    marginTop: 18,
    background: "#ffffff",
    borderRadius: 18,
    padding: 18,
    border: "1px solid #e5e7eb",
    boxShadow: "0 12px 30px rgba(15,23,42,.08)",
  },

  label: {
    display: "block",
    marginTop: 14,
    marginBottom: 8,
    fontWeight: 900,
    color: "#111827",
    fontSize: 14,
  },

  grillaNotas: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(58px, 1fr))",
    gap: 10,
    marginTop: 8,
    marginBottom: 12,
  },

  botonNota: {
    height: 56,
    borderRadius: 16,
    color: "#fff",
    fontWeight: 900,
    fontSize: 20,
    cursor: "pointer",
    transition: "all .18s ease",
    outline: "none",
  },

  resultadoNota: {
    marginTop: 10,
    marginBottom: 6,
    padding: "12px 14px",
    borderRadius: 14,
    background: "#f1f5f9",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 10,
    border: "1px solid #e2e8f0",
  },

  resultadoTexto: {
    fontWeight: 900,
    color: "#0f172a",
  },

  resultadoNumero: {
    background: "#111827",
    color: "#fff",
    borderRadius: 999,
    padding: "6px 12px",
    fontWeight: 900,
  },

  input: {
    width: "100%",
    padding: "12px 14px",
    borderRadius: 14,
    border: "1px solid #cbd5e1",
    background: "#f8fafc",
    color: "#111827",
    fontWeight: 700,
    outline: "none",
  },

  textarea: {
    width: "100%",
    padding: "12px 14px",
    borderRadius: 14,
    border: "1px solid #cbd5e1",
    background: "#f8fafc",
    color: "#111827",
    resize: "vertical",
    outline: "none",
    fontWeight: 600,
    lineHeight: 1.45,
  },

  boton: {
    marginTop: 18,
    width: "100%",
    border: "none",
    borderRadius: 16,
    padding: "14px 18px",
    background: "linear-gradient(135deg, #2563eb, #1e40af)",
    color: "#fff",
    fontWeight: 900,
    cursor: "pointer",
    fontSize: 15,
    boxShadow: "0 16px 30px rgba(37,99,235,.32)",
    transition: "all .2s ease",
  },

  alerta: {
    padding: 28,
    borderRadius: 18,
    background: "linear-gradient(135deg, #fef2f2, #fff7ed)",
    color: "#991b1b",
    fontWeight: 900,
    textAlign: "center",
    border: "1px solid #fecaca",
    boxShadow: "0 18px 45px rgba(153,27,27,.12)",
  },

  alertaIcono: {
    fontSize: 42,
    marginBottom: 10,
  },

  loadingBox: {
    padding: 35,
    borderRadius: 18,
    background: "#f8fafc",
    border: "1px solid #e2e8f0",
    textAlign: "center",
  },

  loadingText: {
    marginTop: 12,
    fontWeight: 800,
    color: "#334155",
  },

  spinner: {
    width: 42,
    height: 42,
    borderRadius: "50%",
    border: "5px solid #e2e8f0",
    borderTopColor: "#2563eb",
    margin: "0 auto",
    animation: "spin 1s linear infinite",
  },
};

export default EvaluarVideoEntrevista;